import { useMediaQuery } from 'react-responsive';
export const IsDesktopOrLaptop = () => useMediaQuery({ minWidth: 1280 });
export const IsBigScreen = () => useMediaQuery({ minWidth: 1824 });
export const IsTabletOrMobile = () => useMediaQuery({ maxWidth: 1279 });
export const IsPortrait = () => useMediaQuery({ orientation: 'portrait' });
export const IsRetina = () => useMediaQuery({ minResolution: '2dppx' });
